import type { VatCreditStatus } from '@dcc-erp/shared';

export function VatDestinationChip({
  status,
  period,
  isAbbreviated,
}: {
  status: VatCreditStatus | null;
  period: string;
  isAbbreviated: boolean;
}) {
  return (
    <div style={{ display: 'grid', gap: 4 }}>
      {status === 'CLAIMABLE' ? (
        <span className="badge positive">ภาษีซื้อ claimable งวด {period}</span>
      ) : status === 'SUSPENSE' ? (
        <span className="badge warning">ภาษีซื้อค้างรับ</span>
      ) : (
        <span className="muted">—</span>
      )}
      {isAbbreviated && (
        <div className="meta" style={{ color: 'var(--warning)' }}>
          ใบกำกับอย่างย่อ — ขอคืนภาษีซื้อไม่ได้ (ตรึงเป็นภาษีซื้อค้างรับ); การปรับต้องผ่านอนุมัติ
        </div>
      )}
    </div>
  );
}
